import PropTypes from "prop-types";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { 
  selectCurrentLanguage, 
  fetchTranslationDictionary
} from "../../../../redux/WithcookieSlice";
import { useEffect } from "react";
import FooterCopyright from "../../components/footer/FooterCopyright";
import { useTranslation } from "../../../../redux/TranslationHelper";

const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu,
  companyName,
  address,
  phone,
  email,
  snsBanner,
  withcookieData
}) => {
  const logoUrl = withcookieData?.skin?.theme?.main_logo_url || "/assets_flone/img/logo/logo.png";
  
  // Redux 상태 관리
  const dispatch = useDispatch();
  const currentLanguage = useSelector(selectCurrentLanguage);

  // 앱 시작시 다국어 사전 로드
  useEffect(() => {
    dispatch(fetchTranslationDictionary());
  }, [dispatch]);

  // 다국어 처리 훅 사용
  const { t, changeLanguage, getSupportedLanguages } = useTranslation();
  
  // 언어 변경 핸들러
  const handleLanguageChange = (e) => {
    changeLanguage(e.target.value);
  };
  
  // 테마 색상 가져오기
  const theme = withcookieData?.skin?.theme || {};
  const colorSet = theme?.colorset || {};
  const primaryColor = colorSet?.primary || "";
  
  // 푸터 스타일
  const footerStyle = {
    backgroundColor: primaryColor
  };
  
  // 푸터 텍스트 스타일
  // 여기 조정하면 됨
  const footerTextStyle = {
    color: "#FFFFFF", // 흰색 텍스트
    fontSize: "0.875rem"  // 14px로 축소
  };
  
  // 언어 선택 셀렉트 스타일
  const languageSelectStyle = {
    ...footerTextStyle,
    color: 'black',
    backgroundColor: '#aaaaaa',
    border: '1px solid #ffffff',
    borderRadius: '4px',
    padding: '5px 10px',
    cursor: 'pointer',
    marginTop: '10px',
    outline: 'none',
    width: '100%'
  };
  
  // 지원하는 언어 목록
  const supportedLanguages = getSupportedLanguages();


  return (
    <footer 
      className={clsx("footer-area", spaceTopClass, spaceBottomClass, extraFooterClass, spaceLeftClass, spaceRightClass )}
      style={footerStyle}
    >
      <div className={`${containerClass ? containerClass : "container"}`}>
        <div className="row">
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-5" : "col-lg-3 col-sm-5"
            }`}
          >
            {/* footer copyright */}
            <FooterCopyright
              footerLogo={logoUrl}
              spaceBottomClass="mb-30"
              companyName={companyName}
              textStyle={footerTextStyle}
            />
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-6" : "col-lg-4 col-sm-6"
            }`}
          >
            <div className="footer-widget mb-30 ml-30">
              <div className="footer-title">
                <h3 style={footerTextStyle}>{t('회사 정보')}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li style={{marginBottom: '0px'}}>
                    <span className="footer-info-item" style={footerTextStyle}>{companyName}</span>
                  </li>
                  {withcookieData?.skin?.owner && (
                    <li style={{marginBottom: '0px'}}>
                      <span className="footer-info-item" style={footerTextStyle}>{t('대표')}: {withcookieData.skin.owner}</span>
                    </li>
                  )}
                  {withcookieData?.skin?.businessNumber && (
                    <li style={{marginBottom: '0px'}}>
                      <span className="footer-info-item" style={footerTextStyle}>{t('사업자등록번호')}: {withcookieData.skin.businessNumber}</span>
                    </li>
                  )}
                  {withcookieData?.skin?.mailOrderBusinessCertificate && (
                    <li style={{marginBottom: '0px'}}>
                      <span className="footer-info-item" style={footerTextStyle}>{t('통신판매업등록번호')}: {withcookieData.skin.mailOrderBusinessCertificate}</span>
                    </li>
                  )}
                  {address && address !== "" &&  (
                    <li style={{marginBottom: '0px'}}>
                      <span className="footer-info-item" style={footerTextStyle}>{t('주소')}: {address}</span>
                    </li>
                  )}
                  {phone && phone !== "" && (
                    <li style={{marginBottom: '0px'}}>
                      <span className="footer-info-item" style={footerTextStyle}>{t('고객센터')}: {phone}</span>
                    </li>
                  )}
                  {email && email !== "" && (
                    <li style={{marginBottom: '0px'}}>
                      <span className="footer-info-item" style={footerTextStyle}>{t('Email')}: {email}</span>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-4"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
              }`}
            >
              {/* 언어 선택 UI */}
              <div className="footer-title">
                <h3 style={footerTextStyle}>{t('언어 선택')}</h3>
              </div>
              <div className="footer-list">
                <select 
                  value={currentLanguage} 
                  onChange={handleLanguageChange}
                  style={languageSelectStyle}
                >
                  {supportedLanguages.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                      {lang.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-3 col-sm-4" : "col-lg-2 col-sm-6"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-145"
                  : "footer-widget mb-30 ml-75"
              }`}
            >
              {/* <div className="footer-title">
                <h3 style={footerTextStyle}>SNS</h3>
              </div>
              <div className="footer-list">
                <ul>
                  {snsBanner && snsBanner.length > 0 ? (
                    snsBanner.map((sns, index) => (
                      <li key={index}>
                        <a
                          href={sns.url || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{...safelyParseStyle(sns.style), ...footerTextStyle}}
                        >
                          {sns.text || `SNS ${index + 1}`}
                        </a>
                      </li>
                    ))
                  ) : (
                    <>
                      <li>
                        <a
                          href="//www.facebook.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={footerTextStyle}
                        >
                          Facebook
                        </a>
                      </li>
                      <li>
                        <a
                          href="//www.twitter.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={footerTextStyle}
                        >
                          Twitter
                        </a>
                      </li>
                      <li>
                        <a
                          href="//www.instagram.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={footerTextStyle}
                        >
                          Instagram
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </div> */}
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
  companyName: PropTypes.string,
  address: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  snsBanner: PropTypes.array,
  withcookieData: PropTypes.object
};

export default FooterOne;
